import { useQuery } from "@tanstack/react-query";
import fetchToBackend from "@/utils/fetchToBackend";
import { workAdvisoryKeys } from "@/lib/query-keys";
import { normalizeReportData } from "@/lib/workadvisory-report";
import type {
  WorkAdvisoryReport,
  WorkAdvisoryReportSummary,
} from "@/types/workadvisory";

/**
 * El informe del período. Sin `reportId` trae el último publicado, que es lo que
 * se abre al entrar; con id, uno del histórico.
 */
export function useWorkAdvisoryReport(reportId?: number) {
  return useQuery({
    queryKey: workAdvisoryKeys.report(reportId),
    queryFn: async () => {
      const res = await fetchToBackend<{ data: WorkAdvisoryReport | null }>(
        reportId
          ? `/work-advisory/reports/${reportId}`
          : "/work-advisory/reports/latest",
      );
      if (!res.data) return null;
      return {
        ...res.data,
        workadvisoryreport_data: normalizeReportData(
          res.data.workadvisoryreport_data,
        ),
      };
    },
  });
}

/** Los períodos publicados, para el selector. */
export function useWorkAdvisoryHistory() {
  return useQuery({
    queryKey: workAdvisoryKeys.history(),
    queryFn: async () => {
      const res = await fetchToBackend<{ data: WorkAdvisoryReportSummary[] }>(
        "/work-advisory/reports",
      );
      return res.data;
    },
  });
}
